// extracted by mini-css-extract-plugin
export default {"links":"authLinks_links__9x1xO","center":"authLinks_center__phLVq","strong":"authLinks_strong__yzBTa"};